import { CheckboxField, Field, RadioBooleanField } from '../types/field';

import { getMaxValue, getMinValue } from './rangeValue';

export const formatFloatInputValue = (
    field: Field,
    value: string,
    watcher = null,
): number | string => {
    const formattedString = value.replace(/,/g, '.');
    let floatValue;

    if (
        formattedString.split('').filter((char) => char === '.').length <= 1 &&
        formattedString.endsWith('.')
    ) {
        floatValue = value;
    } else {
        floatValue = +parseFloat(formattedString).toFixed(2);
    }
    if (value === '' || (typeof floatValue === 'number' && isNaN(floatValue))) return '';
    return floatValue;
};

export const formatNumberInputValue = (field: Field, value: string): number | string => {
    const floatValue = parseFloat(value);
    if (value === '' || isNaN(floatValue)) return '';
    return floatValue;
};

export const formatTextInputValue = (field: Field, value: string): string => value;

export const formatBooleanValue = (
    field: CheckboxField | RadioBooleanField,
    e: boolean | string,
): boolean => {
    if (e === 'false') {
        e = false;
    }
    return Boolean(e);
};

export const formatRange = (
    field: Field,
    value: string,
    fieldValues: Record<string, any>,
): number | string => {
    /**
     * as we use text input for some numbers field,
     * we need to remove alphabetic characters | dot | comma
     */
    // remove all char | dot | comma except all dig | plus sign
    const cleanValue = value.replace(/[,.]/g, '').replace(/[^0-9+]/g, '');
    const valueToNumber = parseFloat(cleanValue);

    const maxValue = getMaxValue(field, fieldValues);
    if (maxValue && valueToNumber > maxValue) {
        return maxValue;
    }

    const minValue = getMinValue(field, fieldValues);
    if (minValue && valueToNumber <= minValue) {
        return minValue;
    }

    // else if value is NaN we return an empty string else the given value
    return isNaN(valueToNumber) ? '' : valueToNumber;
};

export const findClothestIncrement = (values: number[], value: number) => {
    // Build a array of gaps between values and value with 2 decimals of precision
    const gaps = values.map((elem) => Math.round(Math.abs(elem - value) * 100) / 100);
    const minGap = Math.min(...gaps);
    const index = gaps.findIndex((elem) => elem === minGap);

    return index !== -1 ? values[index] : value;
};

export const formatFloatRange = (
    field: Field,
    value: string,
    fieldValues: Record<string, any>,
    incrementValues?: number[],
): number | string => {
    /**
     * as we use text input for some numbers field,
     * we need to remove alphabetic characters | dot | comma
     */
    const formattedString = value.replace(/,/g, '.');
    if (
        formattedString.split('').filter((char) => char === '.').length <= 1 &&
        formattedString.endsWith('.')
    ) {
        return value;
    }

    let valueToNumber = +parseFloat(formattedString).toFixed(2);

    if (incrementValues && incrementValues.length > 0) {
        valueToNumber = findClothestIncrement(incrementValues, +parseFloat(formattedString));
    }

    const maxValue = getMaxValue(field, fieldValues);
    const minValue = getMinValue(field, fieldValues);

    if (maxValue && valueToNumber > maxValue) {
        return maxValue;
    }

    if (minValue && valueToNumber <= minValue) {
        return minValue;
    }

    // else if value is NaN we return an empty string else the given value
    return isNaN(valueToNumber) ? '' : valueToNumber;
};

export const formatStringWithPlusSign = (value: number | string): number => {
    return typeof value === 'string' ? parseFloat(value.replace(/[+]/g, '')) : value;
};
